import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'
import { cities } from '@services/api'
import { StoreExt } from '@utils/reactExt'

export class citiesStore extends StoreExt {
    @observable list = []
    @observable loading = false
    // @observable paging = {
    //     page: 1,
    //     perPage: 0,
    //     total: 0,
    //     lastPage: 0
    // }

    @action
    getCities = async () => {
        this.loading = true
        const { list } = (await cities.list()).data

        runInAction(() => {
            this.list = list
            // this.paging = { perPage, total, page, lastPage  }
            this.loading = false
        })
    }
}

export default remotedev(new citiesStore())
